import React, { useEffect, useRef, useState } from 'react'
import { useTranslation } from 'react-i18next'

import { GiftConstructor } from '../wallet/notSentGift/NotSentGift'
import MyVirtualGiftPopup from './myVirtualGiftPopup/myVirtualGiftPopup'
import GiftButtons from './giftButtons'

import { UnionGift } from '../../../store/member/memberTypings'
import { giftRead } from '../../../api/gifts'
import './../../profile/wallet/notSentGift/notSentGifts.sass'

interface Props {
    virtualGift: UnionGift
    short?: boolean
    album?: boolean
    userAlbum?: boolean
    isOutgoing?: boolean
}

const VirtualGift = ({ virtualGift, short = false, album = false, userAlbum = false, isOutgoing }: Props) => {
    const [t] = useTranslation()

    const [isPopupOpen, setIsPopupOpen] = useState(false)

    const [giftStyle, setGiftStyle] = useState(['giftConstructor'])
    const [isGiftSeen, setIsGiftSeen] = useState(false)
    const giftRef = useRef(null)

    useEffect(() => {
        if (virtualGift.status === 'new') {
            if (window && 'IntersectionObserver' in window) {
                // @ts-ignore
                const callback = (entries, observer) => {
                    if (entries[0].isIntersecting) {
                        giftRead({ id: virtualGift.id })
                        observer.unobserve(entries[0].target)
                        setTimeout(() => setIsGiftSeen(true), 1000)
                    }
                }

                const observer = new IntersectionObserver(callback)

                observer.observe(giftRef.current)
            } else {
                giftRead({ id: virtualGift.id })
            }
        }
    }, [])

    useEffect(() => {
        const additionalStyles = ['giftConstructor']
        if (virtualGift.status === 'new' && !isGiftSeen) additionalStyles.push('newGift')
        if (album) additionalStyles.push('albumGift')
        if (virtualGift.status === 'hidden') additionalStyles.push('hiddenGift')
        setGiftStyle(additionalStyles)
    }, [virtualGift, isGiftSeen])

    return (
        <>
            <div className={giftStyle.join(' ')} ref={giftRef}>
                <GiftConstructor giftInfo={virtualGift} album={album} isOutgoing={isOutgoing} />
                {!userAlbum && (
                    <GiftButtons
                        recipient={virtualGift.sender ? virtualGift.sender.nick : null}
                        giftId={virtualGift.id}
                        recipientId={virtualGift.sender ? virtualGift.sender.id : null}
                        giftStatus={virtualGift.status}
                    />
                )}
                {!short && (
                    <>
                        <div className={'viewMessage'} onClick={() => setIsPopupOpen(!isPopupOpen)}>
                            {t('View message')}
                        </div>
                    </>
                )}
            </div>
            {!short && isPopupOpen ? (
                <MyVirtualGiftPopup setExternalState={setIsPopupOpen} virtualGift={virtualGift} />
            ) : (
                <></>
            )}
        </>
    )
}

export default VirtualGift
